import axios from 'axios'
import { camelizeKeys } from 'humps'
import { pick } from 'lodash'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getLocations({ commit }) {
        return axios
            .get('/localization/localizations')
            .then(response => {
                commit('GET_LOCATIONS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie listy lokalizacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    findProductionOrder(context, {query}) {
        return axios
            .get(`/old-production-apps/production-orders?job_number=${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Szukanie zleceń produkcyjnych nie powiodło się.')

                return Promise.reject(error)
            })

    },
    getProductionOrder(context, customId) {
        return axios
            .get(`/old-production-apps/production-orders/${customId}`)
            .then(response => {
                return Promise.resolve(objectDetailModel(response.data))
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych do zlecenia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrder({ commit }, orderNumber) {
        return axios
            .get(`/old-production-apps/orders?detail_nr_zamowienia=${orderNumber}`)
            .then(response => {
                if (response.data.results.length === 0) {
                    commit('SHOW_NOTIFICATION', {
                        type: 'error',
                        message: `Nie odnaleziono zamówienia ${orderNumber}.`
                    }, { root: true })
                }

                return Promise.resolve(objectDetailModel(response.data.results[0]))
            })
            .catch(error => {
                handleApiError(error, 'Szukanie zamówienia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setTasksLocalization(context, data) {
        return axios
            .post('/localization/localization-collector', data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Ustawienie lokalizacji nie powiodło się.')

                return Promise.reject(error)
            })
    }
}

function objectDetailModel(object) {
    const objectDetailKeys = [
        'custom_id',
        'detail_id',
        'detail_nr_zamowienia',
        'format',
        'gramatura',
        'job_number',
        'lastLocalization',
        'plate_number',
        'naklad',
        'naklad_standard',
        'nazwa',
        'nazwa_papieru',
        'produkt_nazwa',
        'rodzaj_papieru',
        'uszlach_dla_prod',
        'zadruk_globalnie'
    ]

    object = pick(object, objectDetailKeys)

    return camelizeKeys(object)
}